'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultNavHeight = exports.setDefaultNavHeight = undefined;

var _sizes = require('HubStyleTokens/sizes');

var defaultNavHeight = null;

var setDefaultNavHeight = exports.setDefaultNavHeight = function setDefaultNavHeight(navHeight) {
  defaultNavHeight = navHeight;
};

var getDefaultNavHeight = exports.getDefaultNavHeight = function getDefaultNavHeight() {
  return defaultNavHeight || parseInt(_sizes.NAV_BAR_HEIGHT, 10);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/utils/NavHeight.js
// module id = 599
// module chunks = 171